module.exports = {
  apiHost: "https://api.sanctuaryrise.sensoreal.app",
  assetsHost: "https://assets.sanctuaryrise.sensoreal.app",
  brandName: "Sanctuary Rise",
  header: {
    text: { en: "Your Sanctuary Rise Selections" },
    logo:
      "https://assets.sanctuaryrise.sensoreal.app/misc/SanctuaryRise_Portrait_w_WhiteType_CMYK.png",
    companyLogo: "",
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    primaryColor: "#00000c",
    textColor: "#fff",
    font: "aeonik",
  },
  contact: {
    website: "https://sanctuaryrise.com.au",
    address: "",
    phone: "",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },
  footerLogo: "",
};
